import React from "react";
import { remove as removeAccents } from "remove-accents-diacritics";

export function handleClickOutside(
	ref: React.RefObject<any>,
	callback: Function
) {
	document.addEventListener("mousedown", (e) => {
		if (!ref?.current?.contains(e.target)) {
			callback();
		}
	});
}

export function downloadURI(uri: string, name: string) {
	const link = document.createElement("a");
	link.download = name;
	link.href = uri;
	link.target = "_blank";
	link.click();
}

export function waitForExists(name: string, callback: Function) {
	const variable = window[name as any];
	if (typeof variable !== "undefined") {
		return callback(variable);
	}
	setTimeout(() => waitForExists(name, callback), 200);
}

export function accessiblePath(path?: string): string {
	if (!path) {
		return "";
	}
	if (path.startsWith("http")) {
		return path;
	}
	return `${process.env.REACT_APP_API_URL}/${path}`;
}

export function stripText(text: string) {
	if (typeof text !== "string") {
		return text;
	}
	return removeAccents(text.toLowerCase()).replace(/\s/g, "");
}

export function inputDebounce(callback: Function, timeout: number = 500): any {
	let timer: any;
	return (...args: any[]) => {
		clearTimeout(timer);
		timer = setTimeout(() => {
			callback(...args);
		}, timeout);
	};
}

export function objectToFullText(obj: any) {
	let text = "";
	for (let key in obj) {
		let value = obj[key];
		if (typeof value === "object") {
			value = JSON.stringify(value);
		}
		if (typeof value !== "string") {
			value = value.toString();
		}
		text += removeAccents(value.toLowerCase());
	}
	return text;
}
